import { useMutation, useQueryClient } from '@tanstack/react-query';

import { equipmentImagesListKey } from '@components/modals/EditSensorGalleryModal/services/useEquipmentImagesListQuery';

import { hardwareOverviewDetailsKey } from '@pages/HardwareOverviewDetails/services/useHardwareOverviewDetailsQuery';

import { apiClient } from '@services/apiClient';
import { installationPointPhotosKey } from '@services/useInstallationPointPhotosQuery';

interface IData {
  equipmentType: string;
  itemId: string | number;
  newPhotos: { id: number; url: string }[];
}

const equipmentAddPhotoChangeFn = (data: IData) =>
  apiClient.post(`${APP_API_URL}${data.equipmentType}/save-photos/${data.itemId}`, {
    photos: data.newPhotos,
  });

export const useEquipmentAddPhotoMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: equipmentAddPhotoChangeFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [hardwareOverviewDetailsKey()[0]] });
      queryClient.invalidateQueries({ queryKey: [installationPointPhotosKey()[0]] });
      queryClient.invalidateQueries({ queryKey: [equipmentImagesListKey()[0]] });
    },
  });
};
